import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@readsavor/api-client';
import { userQueryKeys } from './useUser';
/**
 * Hook for updating the user's password.
 * On success, it optimistically updates the user query data with the new user and session,
 * providing a smoother UX by avoiding a refetch.
 */
export const useUpdatePassword = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => apiClient.auth.changePassword(data),
        onSuccess: data => {
            // Optimistically update the current user's data in the cache.
            // The query key `userQueryKeys.all` is used by `useUser` to fetch the current user.
            queryClient.setQueryData(userQueryKeys.all, oldUser => {
                // It's good practice to check if old data exists, though in this flow it should.
                if (oldUser) {
                    return {
                        ...oldUser,
                        ...data.user, // Overwrite with the fresh user data from the response
                    };
                }
                return data.user;
            });
            // Note: This hook doesn't manage the session token itself.
            // That responsibility lies with the AuthProvider, which should have a mechanism
            // to update the session when a login-like action (including this one) occurs.
        },
    });
};
//# sourceMappingURL=useUpdatePassword.js.map